import React, {useRef, useState} from 'react'

import type {Resource} from '../../../../../../../utils'

type Props<T> = {
  resource: Resource<T>
  children: (data: T) => React.ReactNode
}

const RetainPrevious = <T,>({resource, children}: Props<T>) => {
  const prevData = useRef<T>()
  const [, forceUpdate] = useState({})

  try {
    prevData.current = resource.read()
  } catch (promiseOrError) {
    if (promiseOrError instanceof Promise && prevData.current !== undefined) {
      void promiseOrError.then(() => {
        forceUpdate({})
      })
    } else {
      throw promiseOrError
    }
  }

  return <>{children(prevData.current)}</>
}

export {RetainPrevious}
